import React from 'react';
import { DropdownMenu as ReactstrapDropdownMenu } from 'reactstrap';
import cn from 'classnames';
import styles from './index.module.scss';

/**
 * @param {Object} props
 * @param {import('utils/types').XAlign} props.align
 * @param {string} props.className
 * @param {React.ReactNode} props.children
 */
export default function DropdownMenu({
  align = 'left',
  className = '',
  children = null
}) {
  return (
    <ReactstrapDropdownMenu
      right={align === 'right'}
      className={cn(styles.container, className)}
    >
      {children}
    </ReactstrapDropdownMenu>
  );
}
